module.exports = __webpack_public_path__ + "img/store.981e3b41.png";